import { useSession } from 'next-auth/react'

import { useGetRobotTypes } from '@modules/RobotTypes/hooks/useGetRobotTypes'

/** Loads the robot types catalog once the user is logged in, so every screen can read it from the query cache. */
export const RobotTypesLoader = () => {
  const { status } = useSession()
  useGetRobotTypes(undefined, { enabled: status === 'authenticated' })
  return null
}
